<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template>
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openEditPage({ pageType: 'add' })"
          >
            {{ $l('btn_add_new') || '新面料申请' }}
          </b-button>
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="chooseNoOrderFabric()"
          >
            {{ $l('btn_add_fabric') || '已有面料申请' }}
          </b-button>
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="chooseOrderFabric()"
          >
            {{ $l('btn_Bulk_fabric') || '大货面料申请' }}
          </b-button>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <ChooseFabric
      :visible.sync="chooseFabricOpts.visible"
      :title="chooseFabricOpts.title"
      :extrasParams="{ isCooperation: 'Y', ...chooseFabricOpts.extrasParams }"
      :confirm-on-close="false"
      @confirm="chooseFabricConfirm"
    />
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageMain from './main.vue'
import ChooseFabric from '@/views/digital/components/choose-fabric'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain, ChooseFabric },
  data() {
    return {
      usePage: true,
      chooseFabricOpts: { visible: false, title: '', extrasParams: {} },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .fabricRequestListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'master-fabricRequest-detail',
        params: { ...params, pageType },
        query,
      })
    },
    chooseNoOrderFabric() {
      this.chooseFabricOpts = {
        visible: true,
        extrasParams: {
          listFabricUseStatus: ['D', 'N', 'P'],
          fabricOwner: 'common',
        },
      }
    },
    chooseOrderFabric() {
      this.chooseFabricOpts = {
        visible: true,
        extrasParams: { listFabricUseStatus: ['O'] },
        title: this.$l('dialog_title_chooseOrderFabric') || '选择大货面料',
      }
    },
    async chooseFabricConfirm({ fabricCode } = {}) {
      if (this.loadingOpen()) return
      const res = await this.$api
        .fabricRequestBuilderApi({ fabricCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('tips_error_requestBuilder') || '生成失败！'
        )
        return
      }
      this.reload()
      this.chooseFabricOpts = { visible: false }
    },
  },
}
</script>
